module.exports = __webpack_public_path__ + "img/013.d8a1815b.jpeg";